module.exports = __webpack_public_path__ + "img/4m3.b6617233.jpg";